import React from "react";

type SpaErrorBoundaryProps = {
  name: string;
  children: React.ReactNode;
};

type SpaErrorBoundaryState = { hasError: boolean };

export class SpaErrorBoundary extends React.Component<SpaErrorBoundaryProps, SpaErrorBoundaryState> {
  constructor(props: SpaErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): SpaErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(this.props.name, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div>Error loading SPA Plugin</div>;
    }
    return this.props.children;
  }
}
